export const DEFAULT_SETTINGS = {
  audioSource: { value: 'default' },
};

export const RecordingStatus = {
  NOT_RECORDING: 'NOT_RECORDING',
  RECORDING: 'RECORDING',
  RECORDING_PAUSED: 'RECORDING_PAUSED',
  FINISHED: 'FINISHED',
} as const;

export type RecordingStatusType =
  (typeof RecordingStatus)[keyof typeof RecordingStatus];
